<div class="modal-header">
  <h4 class="modal-title">{{ 'COST_OVERVIEW' | translate }}</h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="activeModal.dismiss()"
    >
  </button>
</div>
<div class="modal-body">
  <h2>{{ 'COST_OVERVIEW_CALCULATION' | translate }}</h2>
  <app-basket-payment-costs-overview
    [basketQuote]="basketQuote"
    [basketArticlesSum]="basketArticlesSum"
  ></app-basket-payment-costs-overview>

  @if (!basketQuote) {
    <div>{{"LOADING"|translate}}...</div>
  }
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="activeModal.close()">{{ 'CLOSE' | translate }}</button>
</div>